import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { OrganisationListItem } from '@assetaccountant/api/models/organisation-list-item';
import { OrganisationV2Api } from '@assetaccountant/api/services/organisation-v2.api';
import { filterAndSortByValue } from '@assetaccountant/core/utils/search-utils';
import { setupModal, TypedNgbModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CreateOrganisationConfirmModalComponent } from '../create-organisation-confirm-modal/create-organisation-confirm-modal.component';

@Component({
  selector: 'app-switch-organisation-modal',
  templateUrl: './switch-organisation-modal.component.html',
  styleUrls: ['./switch-organisation-modal.component.scss'],
  standalone: false,
})
export class SwitchOrganisationModalComponent {
  @Input() currentOrganistionId?: number;

  @Output() createOrganisation = new EventEmitter();
  @Output() createRegister = new EventEmitter();
  @Output() switchOrganisation = new EventEmitter<OrganisationListItem>();

  get search(): string {
    return this.search$.value;
  }
  set search(value: string) {
    this.search$.next(value);
  }
  private search$ = new BehaviorSubject<string>('');

  hasOtherOrganisations = false;
  showSearch = false;

  private organisations$ = this.organistaionApi.listOrganisations2().pipe(
    map(result => result.result.filter(org => org.organisationId !== this.currentOrganistionId)),
    tap(organisations => {
      this.hasOtherOrganisations = organisations.length > 0;
      this.showSearch = organisations.length > 10;
    }),
  );

  filteredOrganisations$ = combineLatest([this.organisations$, this.search$]).pipe(
    map(([organisations, search]) => {
      if (search.length > 0) {
        return filterAndSortByValue(organisations, search, 'name');
      } else {
        return organisations.sort((a, b) => a.name.localeCompare(b.name));
      }
    }),
  );

  constructor(
    public modal: NgbActiveModal,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
    private organistaionApi: OrganisationV2Api,
  ) {}

  onCreateOrganisation() {
    setupModal(this.ngbModal.open(CreateOrganisationConfirmModalComponent), modal => {
      modal.createOrganisation.subscribe(() => {
        this.createOrganisation.emit();
        this.modal.close();
      });
      modal.createRegister.subscribe(() => {
        this.createRegister.emit();
        this.modal.close();
      });
    });
  }

  onSwitchOrganisation(organisation: OrganisationListItem): void {
    this.switchOrganisation.emit(organisation);
    this.modal.close(organisation);
  }
}
